import { t, font } from "@realtyflows/ui";

/**
 * FolderStatusBadge — V1 Section B
 *
 * Renders a colored pill for a folder's lifecycle state. Designed to be
 * fed straight from the /contract-folders/meta/states endpoint so the
 * frontend stays in sync with backend canonical states.
 *
 * Falls back to a neutral "Draft" badge if the status is unknown so old
 * data doesn't break the UI.
 */

// Maps the color names from folderService.FOLDER_STATE_META → theme tokens.
const colorMap = {
  emerald: t.emerald,
  amber: t.amber,
  sky: t.sky,
  coral: t.coral,
  muted: t.textMuted,
};

const labelMap = {
  draft: "Draft",
  active: "Active",
  in_escrow: "In Escrow",
  pending_review: "Pending Review",
  closed: "Closed",
  archived: "Archived",
};

const stateColorMap = {
  draft: "muted",
  active: "amber",
  in_escrow: "sky",
  pending_review: "amber",
  closed: "emerald",
  archived: "muted",
};

export default function FolderStatusBadge({ status, size = "md" }) {
  const key = status || "draft";
  const colorName = stateColorMap[key] || "muted";
  const color = colorMap[colorName] || t.textMuted;
  const label = labelMap[key] || key;

  const padding = size === "sm" ? "2px 8px" : "3px 10px";
  const fontSize = size === "sm" ? 10 : 11;

  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 5,
      background: color + "15",
      border: `1px solid ${color}40`,
      color,
      padding,
      borderRadius: 6,
      fontFamily: font.mono,
      fontWeight: 700,
      fontSize,
      letterSpacing: 0.3,
      whiteSpace: "nowrap",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: 99, background: color }} />
      {label}
    </span>
  );
}
